module.exports = __webpack_public_path__ + "img/E.Firma-08.8a832583.svg";